import BaseModel from 'models/base-model';

export default class AnnotationDisplayOptions extends BaseModel({
  workpaper: true,
  tickmarks: true,
  internalRef: true,
  formula: true,
  comfortLetter: true,
  flag: true,
  status: true,
  notes: true,
  note: true,
  showAll: false,
  expandAllElements: false,
  workpapersSelected: [],
}) {
  getWorkpapersSelected() {
    return this.workpapersSelected || [];
  }

  setWorkpapersSelected(workpapersSelected) {
    const currentSelected = this.workpapersSelected
      ? [...this.workpapersSelected]
      : [];
    const index = currentSelected.indexOf(workpapersSelected);

    if (index > -1) {
      currentSelected.splice(index, 1);
    } else {
      currentSelected.push(workpapersSelected);
    }

    return this.merge({
      workpapersSelected: currentSelected,
    });
  }

  removeWorkpapersSelected() {
    return this.merge({
      workpapersSelected: [],
    });
  }

  resetAnnotationSidebySideView() {
    return this.merge({
      workpaper: true,
      tickmarks: true,
      internalRef: true,
      formula: true,
      comfortLetter: true,
      flag: true,
      status: true,
      notes: true,
      note: true,
      workpapersSelected: [],
    });
  }
}
